/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function CirclesThree(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Circle cx={128} cy={68} r={48} />
        <Circle cx={188} cy={172} r={48} />
        <Circle cx={68} cy={172} r={48} />
      </G>
    </Svg>
  );
}

export default CirclesThree;
